/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { basecodereference } from 'projects/icemedx-lib/src/models/ehr/subs/basecodereference';
import { requestvalidation } from './requestvalidation';
import { referenceidentification } from './referenceidentification';

export class procedure extends IceEntity {
	procedure_key: string = "";
  date_required: any = NaN;
  end_date_required: any = NaN;
  code_list_qualifier_code: string = "";
  procedure_code: string = "";
  procedure_quantity: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  contraindication: boolean = false;
  interaction: boolean = false;
  synonym: boolean = false;
  required: boolean = false;
  title: string = "";
  procedure_units: string = "";
  strength: number = 0.0;
  strength_form: string = "";
  strength_units: string = "";
  hcr_certification_action_code: string = "";
  hcr_review_identification_number: string = "";
  hcr_review_decision_reason_code: string = "";
  response_message: string = "";
  add_on: boolean = false;
  includes: boolean = false;
  includes_description: string = "";
  excludes1: boolean = false;
  excludes1_description: string = "";
  excludes2: boolean = false;
  excludes2_description: string = "";
  ncci_edits: number = 0;
  ptp_cc_modifier: number = 0;
  ptp_rationale: string = "";
  mue_value: number = 0;
  mue_indicator: number = 0;
  mue_rationale: string = "";
  consider: boolean = false;

  REQRESULTS: requestvalidation[] = [];
  IDS: referenceidentification[] = [];

  gettablename(): string {
    return "PROCEDURE";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "REQRESULTS") return true;
    else if (ColumnName == "IDS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "REQRESULTS") return "REQUEST_VALIDATION";
    else if (ColumnName == "IDS") return "REFERENCE_IDENTIFICATION";

    return null;
  }
}
